import React from 'react';
import './style.css';

interface Props {
    status: string
}

const LivevideoIndicatorComponent:React.FC<Props> = ({ status }) => {
    return (
        <div className='pos-abs indicator-wrapper'>
            <div className={'indicator indicator-' + status} />
            <div className='example'>example</div>
        </div>
    )
};

export default LivevideoIndicatorComponent